import { proxy } from 'valtio';
import { devtools } from 'valtio/utils';

// Note: the spelling "sigatories" (missing 'n') is intentional and matches the
// dialog name used by product. Keep it consistent across actions, model, and
// GlobalFlyout URL handling.
export const EDIT_PARTY_SIGNATORIES_DIALOG = 'edit-party-sigatories';

export const globalSettingsDialogs = new Set([
  'edit-personal',
  'edit-business',
  'edit-trustees',
  'edit-individual-trustees',
  'edit-signatory',
  'revoke-contract',
]);

export enum FlyoutType {
  NONE = 'NONE',

  EDIT_PERSONAL_INFO = 'EDIT_PERSONAL_INFO',
  EDIT_BUSINESS_INFO = 'EDIT_BUSINESS_INFO',
  EDIT_TRUSTEES_INFO = 'EDIT_TRUSTEES_INFO',
  EDIT_INDIVIDUAL_TRUSTEES = 'EDIT_INDIVIDUAL_TRUSTEES',
  EDIT_SIGNATORY = 'EDIT_SIGNATORY',
  EDIT_PERMISSIONS = 'EDIT_PERMISSIONS',
  INVITE_USER = 'INVITE_USER',
  INVITE_PARTY = 'INVITE_PARTY',
  INVITE_QS = 'INVITE_QS',
  APPLY_ACCOUNT = 'APPLY_ACCOUNT',
  PAYMENT_ACCOUNT = 'PAYMENT_ACCOUNT',
  KYC_ONLY = 'KYC_ONLY',
  MANAGE_PAYOUT_ACCOUNT = 'MANAGE_PAYOUT_ACCOUNT',
  ACCOUNT_TRANSFER = 'ACCOUNT_TRANSFER',
  ACCOUNT_TRANSFER_INTRA = 'ACCOUNT_TRANSFER_INTRA',
  ASSIGN_FUNDS = 'ASSIGN_FUNDS',
  TRANSACTION_DETAILS = 'TRANSACTION_DETAILS',
  TRANSACTION_HISTORY = 'TRANSACTION_HISTORY',

  CREATE_PROJECT = 'CREATE_PROJECT',
  EDIT_PROJECT = 'EDIT_PROJECT',
  ARCHIVE_PROJECT = 'ARCHIVE_PROJECT',
  DELETE_PROJECT = 'DELETE_PROJECT',

  JOIN_CONTRACT = 'JOIN_CONTRACT',
  REVIEW_CONTRACT = 'REVIEW_CONTRACT',
  SIGN_CONTRACT = 'SIGN_CONTRACT',
  REVOKE_CONTRACT = 'REVOKE_CONTRACT',
  RECALL_CONTRACT = 'RECALL_CONTRACT',
  RETIRE_USER_GROUP = 'RETIRE_USER_GROUP',
  UNJOIN_CONTRACT = 'UNJOIN_CONTRACT',
  ABANDON_CONTRACT = 'ABANDON_CONTRACT',
  DELETE_DRAFT_CONTRACT = 'DELETE_DRAFT_CONTRACT',
  INVITE_BY_EMAIL = 'INVITE_BY_EMAIL',
  INVITE_BY_LINK = 'INVITE_BY_LINK',
  CONTRACT_DETAILS = 'CONTRACT_DETAILS',
  CONTRACT_NAVIGATOR = 'CONTRACT_NAVIGATOR',

  SET_COMMENCEMENT_DATE = 'SET_COMMENCEMENT_DATE',
  SET_COMPLETION_DATE = 'SET_COMPLETION_DATE',
  TIMELINE_DETAILS = 'TIMELINE_DETAILS',

  LINKED_PAYMENTS = 'LINKED_PAYMENTS',
  PAYMENT_DETAILS = 'PAYMENT_DETAILS',
  FUNDING_DETAILS = 'FUNDING_DETAILS',

  SUPER_CLAIM = 'SUPER_CLAIM',
  UPDATE_CLAIM = 'UPDATE_CLAIM',
  PAY_CLAIM = 'PAY_CLAIM',
  CLAIM_DETAILS = 'CLAIM_DETAILS',
  WORK_ITEM_DETAILS = 'WORK_ITEM_DETAILS',
  PAYMENT_REQUEST_DETAILS = 'PAYMENT_REQUEST_DETAILS',
  ABANDON_PAYMENT_REQUEST = 'ABANDON_PAYMENT_REQUEST',

  NEW_VARIATION = 'NEW_VARIATION',
  AMEND_VARIATION = 'AMEND_VARIATION',
  REVIEW_VARIATION = 'REVIEW_VARIATION',
  ABANDON_VARIATION = 'ABANDON_VARIATION',
  VARIATION_DETAILS = 'VARIATION_DETAILS',

  ABANDON_ADJUSTMENT = 'ABANDON_ADJUSTMENT',
  ADJUSTMENT_DETAILS = 'ADJUSTMENT_DETAILS',

  SECURE_PAYMENT = 'SECURE_PAYMENT',
  SECURE_VARIATION = 'SECURE_VARIATION',
  EARLY_RELEASE = 'EARLY_RELEASE',

  ACCOUNT_DETAILS = 'ACCOUNT_DETAILS',
  DEPOSIT_REFUND = 'DEPOSIT_REFUND',
  CONTRACT_TERMINATE = 'CONTRACT_TERMINATE',
  CLAIM_ASSESSMENT = 'CLAIM_ASSESSMENT',
  REQUEST_ASSESSMENT = 'REQUEST_ASSESSMENT',

  HELP_CENTER = 'HELP_CENTER',
  CHECKOUT = 'CHECKOUT',

  NEW_LINKING = 'NEW_LINKING',

  SUPER_CONTRACT = 'SUPER_CONTRACT',
  PROJECT_FILTERS = 'PROJECT_FILTERS',
  CONTRACT_FILTERS = 'CONTRACT_FILTERS',
  PROJECT_CONTRACT_FILTERS = 'PROJECT_CONTRACT_FILTERS',
  CLAIM_FILTERS = 'CLAIM_FILTERS',
  PROJECT_CLAIMS_FILTERS = 'PROJECT_CLAIMS_FILTERS',
  BULK_PAYMENT = 'BULK_PAYMENT',

  PROJECT_SELECT = 'PROJECT_SELECT',
  PROJECT_BUDGET = 'PROJECT_BUDGET',
  PROJECT_DRAWN_TO_DATE = 'PROJECT_DRAWN_TO_DATE',
  PROJECT_COST_TO_COMPLETE = 'PROJECT_COST_TO_COMPLETE',
  PROJECT_DRAWDOWNS = 'PROJECT_DRAWDOWNS',
  PROJECT_LOAN_ADJUSTMENTS = 'PROJECT_LOAN_ADJUSTMENTS',
  EDIT_PROJECT_BUDGET = 'EDIT_PROJECT_BUDGET',
  PROJECT_PARTIES = 'PROJECT_PARTIES',
  PROJECT_CONTRACTS = 'PROJECT_CONTRACTS',
  PARTY_CONTRACTS = 'PARTY_CONTRACTS',

  FORMS = 'FORMS',
  PROJECT_FORMS = 'PROJECT_FORMS',
  UPLOAD_SIGNED_CONTRACT = 'UPLOAD_SIGNED_CONTRACT',
  CHANGE_PRIMARY_CONTACT = 'CHANGE_PRIMARY_CONTACT',
  UPDATE_FEE_STRUCTURE = 'UPDATE_FEE_STRUCTURE',

  EDIT_DIRECTOR_STRUCTURE = 'EDIT_DIRECTOR_STRUCTURE',
  SET_DEFAULT_SIGNATORIES = 'SET_DEFAULT_SIGNATORIES',
  EDIT_PARTY_SIGNATORIES = 'EDIT_PARTY_SIGNATORIES',

  SECURE_PAID_PRELOAD = 'SECURE_PAID_PRELOAD',
  UNSECURE_PAID_PRELOAD = 'UNSECURE_PAID_PRELOAD',
  ACCESS_LINKED_CONTRACTS = 'ACCESS_LINKED_CONTRACTS',

  RECALL_CLAIM = 'RECALL_CLAIM',
  UPDATE_CLAIM_AMOUNT = 'UPDATE_CLAIM_AMOUNT',
  UNSHARED_DRAFTS = 'UNSHARED_DRAFTS',
  SUBMIT_CLAIM = 'SUBMIT_CLAIM',

  SUBMIT_RETENTION_RETURN = 'SUBMIT_RETENTION_RETURN',
  REVIEW_RETENTION_RETURN = 'REVIEW_RETENTION_RETURN',
  RETENTION_RETURN_HISTORY = 'RETENTION_RETURN_HISTORY',
  RETENTION_RETURN_DETAILS = 'RETENTION_RETURN_DETAILS',

  CONTRACT_REQUIRED_ACTIONS = 'CONTRACT_REQUIRED_ACTIONS',
  CONTRACT_QS_REPORTS = 'CONTRACT_QS_REPORTS',
  CONTRACT_DOCUMENTS = 'CONTRACT_DOCUMENTS',
  CONTRACT_PAYMENTS = 'CONTRACT_PAYMENTS',
  CONTRACT_VARIATIONS = 'CONTRACT_VARIATIONS',
  CONTRACT_RETENTION = 'CONTRACT_RETENTION',
}

export enum NestedFlyoutType {
  NONE = 'NONE',

  VERIFY_MOBILE = 'VERIFY_MOBILE',
  IDENTITY_CHECK = 'IDENTITY_CHECK',

  EDIT_TRUSTEE = 'EDIT_TRUSTEE',
  EDIT_PERSONAL = 'EDIT_PERSONAL',
  EDIT_BUSINESS = 'EDIT_BUSINESS',
  EDIT_INDIVIDUAL_TRUSTEE = 'EDIT_INDIVIDUAL_TRUSTEE',
  EDIT_SIGNATORY = 'EDIT_SIGNATORY',

  COMPLETE_PROFILE = 'COMPLETE_PROFILE',

  SECUREPAID_DOC = 'SECUREPAID_DOC',
  EVIDENCE_MAP_VIEW = 'EVIDENCE_MAP_VIEW',
  RETENTION_CLAIM_DETAILS = 'RETENTION_CLAIM_DETAILS',

  REVOKE_CONTRACT = 'REVOKE_CONTRACT',
  DELETE_DRAFT_CONTRACT = 'DELETE_DRAFT_CONTRACT',
}

// Flyouts opened programmatically (no `dialog` query param). The URL-driven
// effect in `GlobalFlyout` must not close these in its default case.
export const programmaticOnlyFlyouts = new Set<FlyoutType>();

export interface FlyoutState {
  type: FlyoutType;
  pathname: string;
  search?: string;
  data?: Record<string, unknown> | null;
}

/**
 * Fresh default state.
 *
 * This MUST stay a factory rather than a shared object literal. Valtio caches
 * object -> proxy identity, so a single literal binds `stack` / `details` /
 * `nestedDetails` to one proxy instance for the lifetime of the module. Every
 * later `Object.assign(flyoutManager, initialState)` then resolves those keys
 * through the cache back to the same, already-mutated proxies — the reset
 * silently does nothing, and `stack` in particular accumulates forever.
 * Deleting the keys first (`resetProxy`) does not help; the cache lookup happens
 * on assignment. See PWA-16081.
 */
export const createInitialState = () => ({
  open: false,
  className: '',
  /**
   * Whether opening a nested flyout widens this one to the full viewport.
   *
   * The expansion is there so the parent stays readable beside the nested panel, which
   * works when the parent is already near-full-width — growing to `100vw` is a nudge. A
   * narrow flyout cannot benefit: the nested panel is 752px wide and would cover it either
   * way, so all the expansion does is throw the parent's content across the screen and
   * back. Those opt out and let the nested panel sit squarely on top.
   */
  expandOnNested: true,
  showCloseIcon: false,
  nestedOpen: false,
  nestedType: NestedFlyoutType.NONE,
  nestedDetails: {} as Record<string, any>,
  type: FlyoutType.NONE,
  closeOnClickOutside: false,
  closeOnEscapeKeyDown: true,
  stack: [] as FlyoutState[],
  details: {} as Record<string, any>,
  closeCallback: () => {},
});

export type FlyoutManagerState = ReturnType<typeof createInitialState>;

export const flyoutManager = proxy(createInitialState());

devtools(flyoutManager, {
  name: 'Global Flyout',
  enabled: false,
});
